export type AssignmentPlanned = {
    id: number;
    name: string;
    description: string;
    user_id: string;
    created_at: string;
    updated_at: string;
}

export type ChangeLogItem = {
    id: number;
    table_name: string;
    operation: "INSERT" | "DELETE" | "UPDATE";
    updated_at: string;
    record_id: string;
    user_id: string;
    metadata: Record<string, any>;
}

export type NoteCountCache = Record<string, number>;
export type ThemeLikeCache = Record<string, boolean>;
export type PlannedAssignmentCache = Record<string, AssignmentPlanned>;
export type RecentChangeLogIds = Set<number>;

export const tableNameMap: Record<string, string> = {
    "note_counts": "cached_note_counts",
    "theme_likes": "cached_theme_likes",
    "planned_assignments": "cached_planned_assignments",
}